import moment from 'moment-timezone';
import { isValidISOString } from './validate';
export const getFormattedDate = (date) => {
    if (!isValidISOString(date))
        return 'Invalid date';
    // e.g. "14 April 2022"
    return moment.utc(date).format('D MMMM YYYY');
};
